export default __webpack_public_path__ + "static/media/favicon.14350c49.ico";